import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { BiCheck } from "react-icons/bi";
import { AlertFillIcon } from '@primer/octicons-react';
import { useTranslation } from 'react-i18next';
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import configInfo from '../config/config.json';
import TemplateListView    from "./TemplateListView";
import RoleAdminDetailsView from "./RoleAdminDetailsView";
import RoleAdminNewView     from "./RoleAdminNewView";


const RoleAdmin = () => {

  const { t }       = useTranslation(["common","custom"]);
  const { user }    = useContext(UserContext);
  const navigate    = useNavigate();

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["UserAdminWriteAccess", "OrgAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      name: t("I18N_Role_name"),
      sortable: true,
      sortField: 'name',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Role_name") + " (" + t("custom:I18N_Language_2") + ")",
      selector: row => row.nameLang2,
      sortable: true,
      sortField: 'nameLang2',
      grow: 2,
      omit: !configInfo.uiConfig.visibleFields.ROLE_NameLang2
    },
    {
      name: t("I18N_Role_name") + " (" + t("custom:I18N_Language_3")+ ")",
      selector: row => row.nameLang3,
      sortable: true,
      sortField: 'nameLang3',
      grow: 2,
      wrap: true,
      omit: !configInfo.uiConfig.visibleFields.ROLE_NameLang3
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Data_integrity"),
      cell: row => (
        !row.dataIntegrity ? <><span style={{color: 'red'}}>  <AlertFillIcon size={16} /></span>  <span style={{marginLeft:'5px', color: 'red'}}>  {t("I18N_Integrity_check_failed")} </span></> :
                             <><span style={{color: 'green'}}><BiCheck size={16} />      </span>  <span style={{marginLeft:'5px', color: 'green'}}>{t("I18N_Integrity_check_success")}</span></>
      ),
      grow: 0.5,
      omit: !configInfo.appConfig.checkDataIntegrity
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----

  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_IDENT_MGMT_API}
                                                  apiObjName={'roles'}
                                                  listPageTitle={t("I18N_Role_Mgmt")}
                                                  newObjTooltip={t("I18N_TIP_New_role")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Role_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_role")}
                                                  tableColumns={tableColumns}
                                                  primaryIdColType={'NAME'}
                                                  deletePermission={'OrgAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <RoleAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <RoleAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default RoleAdmin;
